import { useId } from "react";

export function BankCardIcon({ className }: { className?: string }) {
  const id = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="23"
      fill="none"
      viewBox="0 0 28 23"
      className={className}
    >
      <path
        fill="#fff"
        fillOpacity=".2"
        d="M22.167.203H5.833a5.7 5.7 0 0 0-4.122 1.792A6.27 6.27 0 0 0 0 6.315h28a6.27 6.27 0 0 0-1.71-4.32A5.7 5.7 0 0 0 22.166.203"
      />
      <path
        fill={`url(#${id}-b)`}
        fillOpacity=".3"
        d="M22.167.203H5.833a5.7 5.7 0 0 0-4.122 1.792A6.27 6.27 0 0 0 0 6.315h28a6.27 6.27 0 0 0-1.71-4.32A5.7 5.7 0 0 0 22.166.203"
      />
      <path
        fill="#fff"
        fillOpacity=".2"
        d="M0 16.092a6.27 6.27 0 0 0 1.71 4.32 5.7 5.7 0 0 0 4.123 1.791h16.334a5.7 5.7 0 0 0 4.122-1.792A6.27 6.27 0 0 0 28 16.092V8.759H0zm8.167-.611c0 .363-.103.717-.295 1.018a1.77 1.77 0 0 1-.786.676c-.32.138-.671.175-1.01.104a1.73 1.73 0 0 1-.897-.502 1.86 1.86 0 0 1-.479-.938 1.9 1.9 0 0 1 .1-1.06c.132-.335.357-.621.644-.822.288-.202.627-.31.973-.31.464 0 .909.194 1.237.537s.513.81.513 1.297"
      />
      <path
        fill={`url(#${id}-c)`}
        fillOpacity=".3"
        d="M0 16.092a6.27 6.27 0 0 0 1.71 4.32 5.7 5.7 0 0 0 4.123 1.791h16.334a5.7 5.7 0 0 0 4.122-1.792A6.27 6.27 0 0 0 28 16.092V8.759H0zm8.167-.611c0 .363-.103.717-.295 1.018a1.77 1.77 0 0 1-.786.676c-.32.138-.671.175-1.01.104a1.73 1.73 0 0 1-.897-.502 1.86 1.86 0 0 1-.479-.938 1.9 1.9 0 0 1 .1-1.06c.132-.335.357-.621.644-.822.288-.202.627-.31.973-.31.464 0 .909.194 1.237.537s.513.81.513 1.297"
      />

      <defs>
        <linearGradient
          id={`${id}-b`}
          x1="22.643"
          x2="1.267"
          y1="22.203"
          y2="5.408"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0" />
          <stop offset=".5" stopColor="#fff" stopOpacity=".2" />
          <stop offset="1" stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id={`${id}-c`}
          x1="22.643"
          x2="1.267"
          y1="22.203"
          y2="5.408"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0" />
          <stop offset=".5" stopColor="#fff" stopOpacity=".2" />
          <stop offset="1" stopColor="#fff" />
        </linearGradient>
        <clipPath id={`${id}-a`} transform="translate(4 3.797)">
          <path d="M22.167.203H5.833a5.7 5.7 0 0 0-4.122 1.792A6.27 6.27 0 0 0 0 6.315h28a6.27 6.27 0 0 0-1.71-4.32A5.7 5.7 0 0 0 22.166.203M0 16.092a6.27 6.27 0 0 0 1.71 4.32 5.7 5.7 0 0 0 4.123 1.791h16.334a5.7 5.7 0 0 0 4.122-1.792A6.27 6.27 0 0 0 28 16.092V8.759H0zm8.167-.611c0 .363-.103.717-.295 1.018a1.77 1.77 0 0 1-.786.676c-.32.138-.671.175-1.01.104a1.73 1.73 0 0 1-.897-.502 1.86 1.86 0 0 1-.479-.938 1.9 1.9 0 0 1 .1-1.06c.132-.335.357-.621.644-.822.288-.202.627-.31.973-.31.464 0 .909.194 1.237.537s.513.81.513 1.297" />
        </clipPath>
      </defs>
    </svg>
  );
}
